import { PREMIUM_TYPE } from 'constants/common';

import { premiumTypesOptions } from './PaymentSettings.config';

export const convertDataToForm = (data: any) => ({
  premiumPrice: data?.premiumPrice || '',
  premiumOldPrice: data?.premiumOldPrice || '',
  premiumType: premiumTypesOptions.find(
    (paymentTypeOption: any) => paymentTypeOption.value === data?.premiumType,
  ) || { label: 'Subscription', value: PREMIUM_TYPE.SUBSCRIPTION },
  premiumPriceId: data?.premiumPriceId || '',
});

export const convertDataToApi = (data: any) => ({
  premiumPrice: Number(data.premiumPrice) || null,
  premiumOldPrice: Number(data.premiumOldPrice) || null,
  premiumType: data.premiumType.value,
  premiumPriceId: data.premiumPriceId || '',
});
